module.exports = __webpack_public_path__ + "img/Space.edfd6c5a.jpg";